import { Link } from 'react-router-dom';

import styles from './styles.module.css';

type HeaderLinkProps = {
  to: string;
  icon: React.ReactNode;
  text: string;
  showDivider?: boolean;
  disabled?: boolean;
  isLink?: boolean;
  onClick?: () => void;
};

const HeaderLink = ({ to, icon, text, onClick, showDivider = true, disabled = false, isLink }: HeaderLinkProps) => {
  if (disabled) {
    return (
      <>
        <span className={`${styles.link} ${styles.disabled}`} onClick={e => e.stopPropagation()}>
          <span className={styles.container}>
            {icon}
            <p className={styles.text}>{text}</p>
          </span>
        </span>
        {showDivider && <div className={styles.divider} />}
      </>
    );
  }

  if (!isLink) {
    return (
      <>
        <span className={styles.link} onClick={onClick}>
          <span className={styles.container}>
            {icon}
            <p className={styles.text}>{text}</p>
          </span>
        </span>
        {showDivider && <div className={styles.divider} />}
      </>
    );
  }

  return (
    <>
      <Link to={to} className={styles.link} onClick={onClick}>
        <span className={styles.container}>
          {icon}
          <p className={styles.text}>{text}</p>
        </span>
      </Link>
      {showDivider && <div className={styles.divider} />}
    </>
  );
};

export default HeaderLink;
